export default "__VITE_ASSET__7_q9qHvL__"